import { http } from 'utils'
import { AxiosResponse } from 'axios'

import { BulkTransactionsTypes, BulkTransactionsTxServiceTypes, BatchLookupTypes, LookupBatchListsServiceTypes, GetTraderListTypes, TraderListTypes, BulkMemberUpdateTypes } from 'types/bulkTransactionsTXTypes'

export async function postBulkTransactionsAPI({
  transactionTypeId,
  fromTraderId,
  deviceCode,
  toTraderIds,
  transactionDate,
  purchaseValue,
  voucherValue,
  loyaltyValue,
  creditValue,
  paymentMethodId,
  manualEntryTypeId,
  glCode,
  addToCode,
  consolidationCode,
  comments,
  custom1,
  custom2,
  custom3,
  flTest,
  flManualOverride,
  flOnline,
}: BulkTransactionsTypes): Promise<BulkTransactionsTxServiceTypes> {
  const url = '/manual-transaction/bulk-transactions'
  const data = {
    transactionTypeId,//transactiontype
    fromTraderId,//merchantId from merchantlookup
    deviceCode,//not needed
    toTraderIds,//coming from getTraderList api response
    transactionDate,
    purchaseValue,
    voucherValue,//need a new field
    loyaltyValue,
    creditValue,//disable value fields depends on transactiontype
    paymentMethodId,//not needed
    manualEntryTypeId,//not needed
    glCode,//not needed
    addToCode,//not needed
    consolidationCode,//not needed
    comments,
    custom1,//not needed
    custom2,//not needed
    custom3,//not needed
    flTest,//mandatory - pass 0
    flManualOverride,//mandatory - pass 0
    flOnline//mandatory - pass 0
  }
  const response = await http.post(url, data)
  return response.data
}

export async function postGetBatchListsAPI({
  batchId,
  batchName,
  batchStatusId,
  dataSourceTypeId,
  traderTypeId,
  flTest,
  flBusiness,
  flGeneric,
  traderCountMinimum,
  traderCountMaximum,
  tradersMaximumMin,
  tradersMaximumMax,
  identTypeId,
  identCreationModeId,
}: LookupBatchListsServiceTypes): Promise<BatchLookupTypes> {
  const url = '/lookup/batches'
  const data = {
    batchId,
    batchName,
    batchStatusId,
    dataSourceTypeId,
    traderTypeId,
    flTest,
    flBusiness,
    flGeneric,
    traderCountMinimum,
    traderCountMaximum,
    tradersMaximumMin,
    tradersMaximumMax,
    identTypeId,
    identCreationModeId,
  }
  const response = await http.post(url, data)
  return response.data
}

export async function postGetTraderListAPI({
  startCardNumber,
  endCardNumber,
  batchId,
}: GetTraderListTypes): Promise<TraderListTypes> {
  const url = '/members/trader-list'
  const data = {
    startCardNumber,
    endCardNumber,
    batchId,
  }
  const response = await http.post(url, data)
  return response.data
}

export async function postBulkMemberUpdateAPI({
  toTraderIds,
  traderStatusId,
}: BulkMemberUpdateTypes): Promise<AxiosResponse> {
  const url = '/members/bulk-update'
  const data = {
    toTraderIds,
    traderStatusId,
  }
  const response = await http.patch(url, data)
  return response
}